import styled from 'styled-components'

import { helpers } from 'styles'

type Props = {
	expand?: boolean
	right?: boolean
}

export const Cell = styled.div<Props>`
	color: ${helpers.color.text};

	flex: ${({ expand }) => (expand ? '1' : 'initial')};
	text-align: ${({ right }) => (right ? 'right' : 'left')};
`
